/*
 * @Author: Enzo
 * @Date: 2021-07-11 11:25:43
 * @LastEditTime: 2021-07-28 18:07:15
 * @LastEditors: Enzo
 * @Description:
 * @FilePath: /waimai_cd_fe_greentech_c/src/utils/config.js
 * God is watching you
 */

// 表单
export const cols = { field: { span: 8, offset: 0 }, label: { span: 3, offset: 0 } };

// 申报年份
export const APPLY_YEAR = '2026';
export const APPLY_PERIOD_CHINESE = '六';

// 申报类型
export const PAGE_TYPE = 'pageType';

export const DOWNLOAD_REVIEW_SCIENTIST = 'https://s3plus.meituan.net/v1/mss_4662117880a641b09d8a16636fb73609/greentech-public/%E7%BE%8E%E5%9B%A2%E9%9D%92%E5%B1%B1%E7%A7%91%E6%8A%80%E5%A5%96%E8%AF%84%E5%AE%A1%E6%89%93%E5%88%86%E8%A1%A80721.docx';
export const DOWNLOAD_REVIEW_INNOVATE = 'https://s3plus.meituan.net/v1/mss_4662117880a641b09d8a16636fb73609/greentech-public/0721%E2%80%9C%E7%A7%91%E5%88%9B%E4%B8%AD%E5%9B%BD%E2%80%9C-%E7%BE%8E%E5%9B%A2%E9%9D%92%E5%B1%B1%E7%8E%AF%E4%BF%9D%E7%A7%91%E6%8A%80%E5%88%9B%E6%96%B0%E7%A4%BA%E8%8C%83%E9%A1%B9%E7%9B%AE%E8%AF%84%E5%AE%A1%E6%89%93%E5%88%86%E8%A1%A8.docx';
// https://km.sankuai.com/page/1000647769
export const downloadUrls = {
  //0721-科创中国-美团青山环保科技创新示范项目申报书.docx
  innoApply:
    'https://s3plus.meituan.net/v1/mss_4662117880a641b09d8a16636fb73609/greentech-public/%E7%A7%91%E5%88%9B%E4%B8%AD%E5%9B%BD-%E7%BE%8E%E5%9B%A2%E9%9D%92%E5%B1%B1%E7%8E%AF%E4%BF%9D%E7%A7%91%E6%8A%80%E5%88%9B%E6%96%B0%E7%A4%BA%E8%8C%83%E9%A1%B9%E7%9B%AE%E7%94%B3%E6%8A%A5%E4%B9%A6-10.11.docx',
  sciApply: 'https://s3plus.meituan.net/v1/mss_4662117880a641b09d8a16636fb73609/greentech-public/%E9%9D%92%E5%B1%B1%E7%A7%91%E6%8A%80%E5%A5%96%E7%94%B3%E6%8A%A5%E4%B9%A6-10.11.docx',
};

const configs = {
  url: 'http://greentech.waimai.test.sankuai.com/api/greentech/c/user/redirect',
  authUrl: 'http://passport.fe.st.sankuai.com/account',
  newAuthUrl: 'http://passport.fe.test.sankuai.com',
};

window._node_env = process.env.NODE_ENV;

if (window.location.host === 'greentech.waimai.test.sankuai.com') {
  // 开发测试
  configs.newAuthUrl = 'http://passport.fe.test.sankuai.com';
  configs.authUrl = 'http://passport.fe.st.sankuai.com/account';
  configs.url = 'http://greentech.waimai.test.sankuai.com/api/greentech/c/user/redirect';
} else if (
  window.location.host === 'waimai-eci-210726-083640-358-sl-greentech.waimai.test.sankuai.com'
) {
  configs.url = 'http://greentech.waimai.test.sankuai.com/api/greentech/c/user/redirect';
} else if (window.location.host === 'waimai-eci-210726-083640-358-sl-greentech.waimai.test.sankuai.com') {
  // 测试
  configs.newAuthUrl = 'http://passport.fe.test.sankuai.com';
  configs.authUrl = 'http://passport.fe.st.sankuai.com/account';
  configs.url = 'http://greentech.waimai.test.sankuai.com/api/greentech/c/user/redirect';
} else if (window.location.host === 'greentech.waimai.st.meituan.com') {
  // staging
  configs.newAuthUrl = 'https://passport.meituan.com';
  configs.authUrl = 'https://passport.meituan.com/account';
  configs.url = 'https://greentech.waimai.st.meituan.com/api/greentech/c/user/redirect';
} else if (window.location.host === 'greentech.meituan.com') {
  // 线上
  configs.newAuthUrl = 'https://passport.meituan.com';
  configs.authUrl = 'https://passport.meituan.com/account';
  configs.url = 'https://greentech.meituan.com/api/greentech/c/user/redirect';
}

export function getAuthUrl() {
  const backUrl = encodeURIComponent(`${configs.url}?continue=${window.location.href}`);
  const logOutUrl = encodeURIComponent(`${configs.url}?continue=${window.location.origin}`);
  return {
    loginUrl: `${configs.newAuthUrl}/useraccount/login?service=b081d468&continue=${backUrl}`,
    logOutUrl: `${configs.authUrl}/signout?service=b081d468&continue=${logOutUrl}`,
  };
}

export function getWaterMarkStr(uid = '') {
  return `青山科技基金保密信息 请勿外传 ${uid}`;
}

export function getApplyTime() {
  // 支持异步用接口获取参数
  return Promise.resolve('2021-8-31');
}
